import RibbonViewState from '../store/schema/RibbonViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsContextualFormatBarShown')(function setIsContextualFormatBarShown(
    ribbonViewState: RibbonViewState,
    isShown: boolean,
    left: number = 0,
    top: number = 0
) {
    ribbonViewState.isContextualFormatBarShown = isShown;
    ribbonViewState.contextualFormatBarLeft = left;
    ribbonViewState.contextualFormatBarTop = top;
});
